(() => {
  const carouselSelector = '.jdgm-cards-carousel';
  const slideSelector = '.jdgm-card';
  const desktopQuery = window.matchMedia('(min-width: 750px)');
  let frameRequested = false;

  const rememberProperty = (slide, property, valueKey, priorityKey) => {
    if (slide.dataset[valueKey] !== undefined) return;
    slide.dataset[valueKey] = slide.style.getPropertyValue(property);
    slide.dataset[priorityKey] = slide.style.getPropertyPriority(property);
  };

  const restoreProperty = (slide, property, valueKey, priorityKey) => {
    if (slide.dataset[valueKey] === undefined) return;

    const value = slide.dataset[valueKey];
    const priority = slide.dataset[priorityKey];
    if (value) slide.style.setProperty(property, value, priority);
    else slide.style.removeProperty(property);

    delete slide.dataset[valueKey];
    delete slide.dataset[priorityKey];
  };

  const enforceFourDesktopSlides = (carousel) => {
    carousel.querySelectorAll(slideSelector).forEach((slide) => {
      if (!desktopQuery.matches) {
        restoreProperty(slide, 'width', 'pawportOriginalWidth', 'pawportOriginalWidthPriority');
        restoreProperty(slide, 'flex-basis', 'pawportOriginalFlexBasis', 'pawportOriginalFlexBasisPriority');
        return;
      }

      rememberProperty(slide, 'width', 'pawportOriginalWidth', 'pawportOriginalWidthPriority');
      rememberProperty(slide, 'flex-basis', 'pawportOriginalFlexBasis', 'pawportOriginalFlexBasisPriority');

      if (slide.style.getPropertyValue('width') !== 'calc(25% - 18px)' || slide.style.getPropertyPriority('width') !== 'important') {
        slide.style.setProperty('width', 'calc(25% - 18px)', 'important');
      }
      if (slide.style.getPropertyValue('flex-basis') !== 'auto' || slide.style.getPropertyPriority('flex-basis') !== 'important') {
        slide.style.setProperty('flex-basis', 'auto', 'important');
      }
    });
  };

  const applyCarouselContract = () => {
    frameRequested = false;
    document.querySelectorAll(carouselSelector).forEach(enforceFourDesktopSlides);
  };

  const scheduleCarouselContract = () => {
    if (frameRequested) return;
    frameRequested = true;
    requestAnimationFrame(applyCarouselContract);
  };

  new MutationObserver(scheduleCarouselContract).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  desktopQuery.addEventListener('change', scheduleCarouselContract);
  window.addEventListener('load', scheduleCarouselContract, { once: true });
  scheduleCarouselContract();
})();
